import { dataHooks } from '../../../libs/dataHooks';

export const newFlowPreviewDataHooks = dataHooks<{
  backToListButton;
  saveTemplateButton;
  iframe;
  readMoreButton;
}>('newFlowPreview');
